import {ScreenOrientation} from '@gongxigames/framework/core';
import {createScrollContainer} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/createScrollContainer';
import {IScrollToFullscreen} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/IScrollToFullscreen';

const MinimumMajorVersion = 15;
const MaxMajorVersion = 16;
const MinimumMinorVersion = 1;
const MaxMinorVersion = 1;

export class ScrollToFullscreen implements IScrollToFullscreen {
    public static instance?: ScrollToFullscreen;
    protected readonly _scrollContainer: HTMLElement;
    protected _isVisibleScrollContainer = false;
    protected _body: HTMLElement;
    protected _touchMoveOnScrollContainerListener: (e: TouchEvent) => void = this.onTouchMoveOnScrollContainer.bind(this);

    public static matchVersion(iOSVersion = ''): boolean {
        const [major = 0, minor = 0]: number[] = iOSVersion.split('_').map(Number);
        const maxVersion = (major < MaxMajorVersion && minor < MaxMinorVersion);

        return major >= MinimumMajorVersion && minor >= MinimumMinorVersion && maxVersion;
    }

    constructor() {
        this._scrollContainer = createScrollContainer();
        this._scrollContainer
            .addEventListener('touchmove', this._touchMoveOnScrollContainerListener, { passive: false, capture: true });
        this._body = document.body;
        ScrollToFullscreen.instance = this;
    }

    public static isFullscreen(): boolean {
        return window.innerHeight >= this.getWindowWithoutBarSize();
    }

    public isFullscreen(): boolean {
        return ScrollToFullscreen.isFullscreen();
    }

    public show(currentOrientation: ScreenOrientation): void {
        if (!this._isVisibleScrollContainer) {
            this.setVisible(currentOrientation);
        }
    }

    protected setVisible(_currentOrientation: ScreenOrientation): void {
        if (!this._scrollContainer.parentElement) {
            this._body.appendChild(this._scrollContainer);
        }

        this._body.style.overflowY = 'scroll';
        this._scrollContainer.style.zIndex = '9999999';
        this._isVisibleScrollContainer = true;
    }

    public hide(currentOrientation: ScreenOrientation): void {
        if (this._isVisibleScrollContainer) {
            this.setInvisible(currentOrientation);
        }
    }

    protected setInvisible(currentOrientation: ScreenOrientation): void {
        this._scrollContainer.style.zIndex = '-1';
        this._body.style.overflowY = '';
        this._isVisibleScrollContainer = false;

        if (currentOrientation === ScreenOrientation.PORTRAIT && this._scrollContainer.parentElement) {
            this._body.removeChild(this._scrollContainer);
        }
    }

    public destroy(): void {
        this._body.style.overflowY = '';

        if (this._scrollContainer.parentElement) {
            this._body.removeChild(this._scrollContainer);
        }
    }

    protected onTouchMoveOnScrollContainer(e: TouchEvent): void {
        if (this.isPortrait()) {
            this.handlePortraitTouchMoveOnScrollContainer(e);
        }
    }

    protected handlePortraitTouchMoveOnScrollContainer(e: TouchEvent): void {
        e.preventDefault();
        e.stopPropagation();
        window.scrollTo(0, 0);
    }

    private static getWindowWithoutBarSize(): number {
        const windowAreaSizeContainer = document.createElement('div');
        const {instance} = ScrollToFullscreen;
        const offset = instance?.isPortrait() ? instance?.getPortraitOffset() : instance?.getLandscapeOffset() || 0;

        document.body.appendChild(windowAreaSizeContainer);

        windowAreaSizeContainer.style.height = '100vh';

        const windowAreaSize = windowAreaSizeContainer.clientHeight;

        document.body.removeChild(windowAreaSizeContainer);

        return windowAreaSize - offset;
    }

    protected isPortrait(): boolean {
        return window.innerHeight > window.innerWidth;
    }

    protected getLandscapeOffset(): number {
        return 0;
    }

    protected getPortraitOffset(): number {
        return 50;
    }
}
